<template>
  <div class="ui middle aligned center aligned grid">
    <div class="column" v-if="showForm">
      <div class="ui success message" v-if="showSuccessMessage">
        <p>{{ $t('pages.resetpassword.form.success') }}</p>
        <router-link :to="{name: 'login'}">{{ $t('pages.resetpassword.redirectlink') }}</router-link>
      </div>
      <div class="ui blue header centered">
        <div class="content">
          {{ $t('pages.resetpassword.header') }}
        </div>
      </div>
      <form class="ui large form" @submit.prevent="sendForm">
        <div class="ui stacked segment">
          <div class="field" :class="{ 'error' : errors.has('email') }">
            <div class="ui input">
              <input type="email" v-model="email" :data-vv-as="$t('pages.resetpassword.form.email')" name="email"
                     :placeholder="$t('pages.resetpassword.form.email')" v-validate="'required|email'" readonly>
            </div>
            <span style="color:red;" v-if="errors.has('email')">{{ errors.first('email') }}</span>
          </div>

          <div class="field" :class="{ 'error' : errors.has('password') }">
            <div class="ui input">
              <input type="password" v-model="password" ref="passwordRef"
                     :data-vv-as="$t('pages.resetpassword.form.password')" name="password"
                     :placeholder="$t('pages.resetpassword.form.password')" v-validate="'required'">
            </div>
            <span style="color:red;" v-if="errors.has('password')">{{ errors.first('password') }}</span>
          </div>

          <div class="field" :class="{ 'error' : errors.has('password_confirmation') }">
            <div class="ui input">
              <input type="password" v-model="password_confirmation"
                     :data-vv-as="$t('pages.resetpassword.form.password_confirmation')" name="password_confirmation"
                     :placeholder="$t('pages.resetpassword.form.password_confirmation')"
                     v-validate="'required|confirmed:passwordRef'">
            </div>
            <span style="color:red;" v-if="errors.has('password_confirmation')">{{
                errors.first('password_confirmation')
              }}</span>
          </div>
          <button type="submit" class="ui large fluid blue button" :disabled="errors.any()">
            {{ $t('pages.resetpassword.form.button') }}
          </button>
        </div>
      </form>
      <div class="ui message centered">
        {{ $t('pages.resetpassword.goback') }}
        <router-link :to="{name: 'login'}">{{ $t('pages.resetpassword.loginlink') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import size from 'lodash/size'

export default {
  name: 'ResetPassword',

  layout: 'default',

  data() {
    return {
      showForm: false,
      email: '',
      password: '',
      password_confirmation: '',

      token: this.$route.params.token ? this.$route.params.token : null,

      showSuccessMessage: false,
      waitBeforeRedirect: 1800
    }
  },

  mounted() {
    this.checkToken()
      .then(result => {
        this.showForm = true
        this.email = result.email

        if (size(this.$auth.user()) > 0) {
          this.$auth.logout({
            makeRequest: true,
            redirect: false
          })
        }
      }).catch(() => {
      this.$router.push('/')
      this.showForm = false

      this.$events.fire('alert', {
        header: this.$t('pages.resetpassword.validation.errors.link_invalid'),
        message: this.$t('pages.resetpassword.validation.errors.try_again'),
        type: 'error',
        align: 'right'
      })
    })
  },

  methods: {
    checkToken() {
      return new Promise((resolve, reject) => {
        this.axios.get(`check-email/${this.token}`)
          .then(({data}) => {
            resolve(data)
          }).catch(error => {
          reject(error)
        })
      })
    },

    sendForm() {
      // POST {{api_url}}/reset-password
      this.$validator.validateAll()
        .then(result => {
          if (result) {
            // send post request
            this.axios.post('/update-password', {
              email: this.email,
              password: this.password,
              password_confirmation: this.password_confirmation,
              token: this.token
            })
              .then(({data}) => {
                if (data.success) {
                  this.showSuccessMessage = true

                  setTimeout(() => {
                    this.$router.push({name: 'login'})
                  }, this.waitBeforeRedirect)
                }
              }).catch(error => {
              const _this = this

              $.map(error.response.data.errors, function (item, index) {
                _this.errors.add({
                  field: index,
                  msg: item[0]
                })
              })
            })
          }
        }).catch()
    }
  }
}
</script>

<style lang="scss" scoped>
.ui.middle.aligned.center.aligned.grid {
  height: 100vh;
  width: 100%;
  justify-content: center;
}

.ui.middle.aligned.center.aligned.grid > .column {
  width: 450px;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/ResetPassword.vue